<section class="pit-card">
  <div class="pit-card__head">
    <div>
      <h3 class="pit-title">Mutação patrimonial</h3>
      <p class="pit-caption">
        Por grupo da ficha Bens e Direitos · R$ mil · variação do último ano e crescimento médio
        anual
      </p>
    </div>
  </div>

  <div class="pit-table-wrap">
    <table class="pit-table">
      <thead>
        <tr>
          <th>Grupo</th>
          @for (year of years(); track year) {
            <th class="num">31/12/{{ year }}</th>
          }
          <th class="num">Var. {{ lastYear() }}</th>
          <th class="num">%</th>
          <th class="num">Média a.a.</th>
        </tr>
      </thead>
      <tbody>
        @for (item of view(); track item.row.group + item.row.groupLabel) {
          <tr [class.is-total]="item.kind === 'total'">
            <td class="is-current">{{ item.label }}</td>
            @for (value of item.values; track $index; let last = $last) {
              <td class="num" [class.is-current]="last">{{ value }}</td>
            }
            <td class="num is-current" [class]="'tone-' + item.changeTone">{{ item.change }}</td>
            <td class="num is-current" [class]="'tone-' + item.changeTone">{{ item.changePct }}</td>
            <td class="num is-current" [class]="'tone-' + item.cagrTone">{{ item.cagr }}</td>
          </tr>
        }
      </tbody>
    </table>
  </div>
</section>
